/* global axios */
import ApiClient from '../ApiClient';

class InboxEvolutionAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  connect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/evolution/connect`);
  }

  status(inboxId) {
    return axios.get(`${this.url}/${inboxId}/evolution/status`);
  }

  reconnect(inboxId) {
    return axios.post(`${this.url}/${inboxId}/evolution/reconnect`);
  }
}

export default new InboxEvolutionAPI();
